export const categories = [
  { slug: 'all', name: '全部作品', icon: 'ri-apps-2-line' },
  { slug: 'romance', name: '恋爱甜宠', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'historical', name: '古风穿越', icon: 'ri-ancient-gate-line' },
];

export const comics = [
  {
    id: 1,
    slug: 'the-legendary-return',
    title: '传奇归来',
    author: '金泰亨',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20warrior%20with%20sword%20in%20magical%20landscape%2C%20dramatic%20lighting%2C%20detailed%20character%20design%2C%20warm%20golden%20and%20crimson%20tones%2C%20dynamic%20composition%2C%20clean%20illustration%20with%20bold%20lines%2C%20professional%20webtoon%20style&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '曾经的最强战士在异世界重生，带着前世的记忆和力量，他誓要改变命运，书写属于自己的传奇故事。一场跨越时空的冒险就此展开。',
    rating: 9.5,
    views: 1280000,
    chapters: 186,
    status: '连载中',
    tags: ['重生', '战斗', '异世界'],
    updatedAt: '2026-08-04',
    chapters_list: [
      { num: 186, title: '新的征程', date: '2026-08-04' },
      { num: 185, title: '最后的试炼', date: '2026-08-01' },
      { num: 184, title: '深渊之谜', date: '2026-07-29' },
      { num: 183, title: '命运的齿轮', date: '2026-07-26' },
      { num: 182, title: '觉醒之力', date: '2026-07-23' },
    ],
  },
  {
    id: 2,
    slug: 'sweet-office-romance',
    title: '甜蜜办公室',
    author: '李智恩',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20young%20couple%20in%20modern%20office%20setting%2C%20soft%20pastel%20pink%20and%20cream%20color%20palette%2C%20gentle%20romantic%20atmosphere%2C%20clean%20webtoon%20illustration%20style%2C%20elegant%20character%20design%2C%20warm%20lighting&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '初入职场的她遇见了冷面上司，两个性格截然不同的人在朝夕相处中擦出爱的火花。一段甜蜜又搞笑的办公室恋情即将上演。',
    rating: 9.3,
    views: 960000,
    chapters: 142,
    status: '连载中',
    tags: ['恋爱', '职场', '甜宠'],
    updatedAt: '2026-08-03',
    chapters_list: [
      { num: 142, title: '意外的告白', date: '2026-08-03' },
      { num: 141, title: '心动的瞬间', date: '2026-07-31' },
      { num: 140, title: '雨中的约定', date: '2026-07-28' },
      { num: 139, title: '她的秘密', date: '2026-07-25' },
      { num: 138, title: '初次约会', date: '2026-07-22' },
    ],
  },
  {
    id: 3,
    slug: 'shadow-hunter',
    title: '暗影猎手',
    author: '朴志勋',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%2C%20dark%20hooded%20hunter%20with%20dual%20blades%20in%20urban%20night%20scene%2C%20neon%20lights%20and%20shadows%2C%20intense%20dramatic%20mood%2C%20cool%20blue%20and%20black%20tones%2C%20detailed%20webtoon%20style%20illustration&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '在黑暗的都市地下世界，有一群专门猎杀怪物的暗影猎手。主角意外获得猎手之力，从此踏上了守护人类世界的危险征程。',
    rating: 9.1,
    views: 850000,
    chapters: 98,
    status: '连载中',
    tags: ['战斗', '都市', '超能力'],
    updatedAt: '2026-08-02',
    chapters_list: [
      { num: 98, title: '最终决战', date: '2026-08-02' },
      { num: 97, title: '暗影之力', date: '2026-07-30' },
      { num: 96, title: '宿命的对决', date: '2026-07-27' },
      { num: 95, title: '新的敌人', date: '2026-07-24' },
      { num: 94, title: '隐藏的真相', date: '2026-07-21' },
    ],
  },
  {
    id: 4,
    slug: 'city-of-stars',
    title: '星之城',
    author: '郑秀妍',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%20art%2C%20elegant%20woman%20in%20city%20nightscape%20with%20stars%2C%20sophisticated%20urban%20atmosphere%2C%20deep%20navy%20and%20silver%20color%20tones%2C%20emotional%20expression%2C%20clean%20webtoon%20illustration%2C%20melancholic%20yet%20beautiful&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '五个年轻人在首尔这座星光璀璨的城市中追逐梦想，他们的命运在繁华都市中交织，演绎出一段段感人至深的人生故事。',
    rating: 9.4,
    views: 720000,
    chapters: 156,
    status: '连载中',
    tags: ['都市', '青春', '励志'],
    updatedAt: '2026-08-04',
    chapters_list: [
      { num: 156, title: '星光璀璨', date: '2026-08-04' },
      { num: 155, title: '最后的舞台', date: '2026-08-01' },
      { num: 154, title: '梦想成真', date: '2026-07-29' },
      { num: 153, title: '离别之夜', date: '2026-07-26' },
      { num: 152, title: '重新出发', date: '2026-07-23' },
    ],
  },
  {
    id: 5,
    slug: 'the-last-witch',
    title: '最后的魔女',
    author: '韩素希',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%2C%20beautiful%20witch%20with%20magical%20powers%20surrounded%20by%20sparkles%2C%20mystical%20purple%20and%20silver%20atmosphere%2C%20ethereal%20character%20design%2C%20magical%20elements%2C%20clean%20webtoon%20style%2C%20enchanting%20composition&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '在魔法逐渐消失的世界里，最后一位魔女踏上了寻找魔法源泉的旅程。她将面对古老预言的考验，决定整个魔法世界的命运。',
    rating: 9.6,
    views: 1100000,
    chapters: 210,
    status: '连载中',
    tags: ['魔法', '冒险', '女主人公'],
    updatedAt: '2026-08-03',
    chapters_list: [
      { num: 210, title: '魔女觉醒', date: '2026-08-03' },
      { num: 209, title: '终极魔法', date: '2026-07-31' },
      { num: 208, title: '最后的守护者', date: '2026-07-28' },
      { num: 207, title: '深渊之门', date: '2026-07-25' },
      { num: 206, title: '古老的契约', date: '2026-07-22' },
    ],
  },
  {
    id: 6,
    slug: 'love-in-seoul',
    title: '首尔恋爱物语',
    author: '金敏雅',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20couple%20walking%20under%20cherry%20blossoms%20in%20Seoul%2C%20soft%20spring%20color%20palette%2C%20romantic%20and%20dreamy%20atmosphere%2C%20beautiful%20character%20design%2C%20clean%20webtoon%20style%2C%20gentle%20warm%20lighting&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '在首尔的樱花季节，两个素未谋面的陌生人因为一场美丽的误会相遇，从此展开了一段跨越四季的浪漫爱情故事。',
    rating: 9.2,
    views: 680000,
    chapters: 88,
    status: '已完结',
    tags: ['恋爱', '治愈', '日常'],
    updatedAt: '2026-07-15',
    chapters_list: [
      { num: 88, title: '永远在一起（大结局）', date: '2026-07-15' },
      { num: 87, title: '樱花下的誓言', date: '2026-07-12' },
      { num: 86, title: '最后的考验', date: '2026-07-09' },
      { num: 85, title: '真心话', date: '2026-07-06' },
      { num: 84, title: '重逢', date: '2026-07-03' },
    ],
  },
  {
    id: 7,
    slug: 'demon-slayer-kim',
    title: '鬼神猎人金氏',
    author: '崔胜贤',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%2C%20demon%20slayer%20with%20ancient%20sword%20in%20traditional%20Korean%20setting%2C%20red%20and%20black%20dynamic%20composition%2C%20intense%20fighting%20pose%2C%20supernatural%20elements%2C%20clean%20webtoon%20style%2C%20dramatic%20lighting&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '金氏家族世代守护人间与鬼界的平衡，当代传人金泰浩继承了先祖的力量，与各路鬼神展开了一场场惊心动魄的战斗。',
    rating: 9.0,
    views: 590000,
    chapters: 120,
    status: '连载中',
    tags: ['战斗', '鬼神', '传统'],
    updatedAt: '2026-08-01',
    chapters_list: [
      { num: 120, title: '终极鬼神', date: '2026-08-01' },
      { num: 119, title: '先祖之力', date: '2026-07-29' },
      { num: 118, title: '封印解除', date: '2026-07-26' },
      { num: 117, title: '暗黑之门', date: '2026-07-23' },
      { num: 116, title: '最后的试炼', date: '2026-07-20' },
    ],
  },
  {
    id: 8,
    slug: 'midnight-detective',
    title: '午夜侦探社',
    author: '尹恩惠',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%2C%20detective%20in%20trench%20coat%20in%20dark%20rainy%20alley%2C%20mysterious%20noir%20atmosphere%2C%20muted%20tones%20with%20spotlight%20accent%2C%20suspenseful%20mood%2C%20clean%20webtoon%20style%2C%20cinematic%20composition&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '首尔深夜的街头，一家不起眼的侦探社里隐藏着不为人知的秘密。主角接手了一个看似普通的失踪案，却逐渐揭开了一个惊天阴谋。',
    rating: 9.3,
    views: 780000,
    chapters: 76,
    status: '连载中',
    tags: ['悬疑', '推理', '都市'],
    updatedAt: '2026-08-04',
    chapters_list: [
      { num: 76, title: '真相大白', date: '2026-08-04' },
      { num: 75, title: '最后的线索', date: '2026-08-01' },
      { num: 74, title: '隐藏的凶手', date: '2026-07-29' },
      { num: 73, title: '第二个受害者', date: '2026-07-26' },
      { num: 72, title: '暗夜追踪', date: '2026-07-23' },
    ],
  },
  {
    id: 9,
    slug: 'high-school-god',
    title: '高校之神',
    author: '宋仲基',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%20art%2C%20funny%20high%20school%20student%20with%20exaggerated%20expression%2C%20bright%20colorful%20school%20setting%2C%20energetic%20and%20playful%20atmosphere%2C%20cartoonish%20webtoon%20style%2C%20vibrant%20colors%2C%20dynamic%20action%20pose&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '一个普通高中生突然被神明选中成为"高校之神"，他必须在学校日常和神明职责之间周旋，闹出了无数令人捧腹的笑话。',
    rating: 8.9,
    views: 520000,
    chapters: 134,
    status: '连载中',
    tags: ['搞笑', '校园', '神明'],
    updatedAt: '2026-08-02',
    chapters_list: [
      { num: 134, title: '神明的假期', date: '2026-08-02' },
      { num: 133, title: '期末考试大作战', date: '2026-07-30' },
      { num: 132, title: '新来的转校生', date: '2026-07-27' },
      { num: 131, title: '运动会风云', date: '2026-07-24' },
      { num: 130, title: '神界来访', date: '2026-07-21' },
    ],
  },
  {
    id: 10,
    slug: 'joseon-doctor',
    title: '朝鲜神医',
    author: '张东健',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20cover%20art%2C%20doctor%20in%20traditional%20Joseon%20hanbok%20with%20medical%20tools%2C%20ancient%20Korean%20palace%20background%2C%20warm%20earthy%20brown%20and%20cream%20tones%2C%20elegant%20traditional%20art%20style%2C%20clean%20webtoon%20illustration&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '现代外科医生意外穿越到朝鲜时代，用现代医学知识在古代宫廷中创造奇迹。他以超凡医术拯救无数生命，书写了一段传奇。',
    rating: 9.5,
    views: 910000,
    chapters: 168,
    status: '连载中',
    tags: ['穿越', '历史', '医学'],
    updatedAt: '2026-08-03',
    chapters_list: [
      { num: 168, title: '宫廷政变', date: '2026-08-03' },
      { num: 167, title: '王室秘药', date: '2026-07-31' },
      { num: 166, title: '瘟疫之战', date: '2026-07-28' },
      { num: 165, title: '异邦来使', date: '2026-07-25' },
      { num: 164, title: '大妃之疾', date: '2026-07-22' },
    ],
  },
  {
    id: 11,
    slug: 'night-cafe',
    title: '深夜咖啡馆',
    author: '朴宝英',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20manhwa%20cover%20art%2C%20mysterious%20cafe%20owner%20behind%20counter%20at%20night%2C%20warm%20candlelight%20and%20dark%20shadows%2C%20intriguing%20atmosphere%2C%20sepia%20and%20deep%20brown%20tones%2C%20clean%20webtoon%20style%2C%20cinematic%20noir%20feel&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '午夜零点开门的咖啡馆，每位客人都带着自己的故事和秘密而来。咖啡馆的主人似乎能看透每个人的内心，这里的咖啡或许不只是咖啡。',
    rating: 9.1,
    views: 450000,
    chapters: 54,
    status: '连载中',
    tags: ['悬疑', '治愈', '奇幻'],
    updatedAt: '2026-08-01',
    chapters_list: [
      { num: 54, title: '最后一杯咖啡', date: '2026-08-01' },
      { num: 53, title: '红衣女子', date: '2026-07-29' },
      { num: 52, title: '失忆的客人', date: '2026-07-26' },
      { num: 51, title: '第七个故事', date: '2026-07-23' },
      { num: 50, title: '雨夜来客', date: '2026-07-20' },
    ],
  },
  {
    id: 12,
    slug: 'dragon-academy',
    title: '龙之学院',
    author: '金钟国',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%2C%20students%20at%20magical%20dragon%20academy%20with%20dragons%20flying%20overhead%2C%20epic%20castle%20background%2C%20vibrant%20orange%20and%20gold%20tones%2C%20adventurous%20atmosphere%2C%20clean%20webtoon%20style%2C%20grand%20composition&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '在培养龙骑士的传奇学院中，一个出身平凡的学生意外与最强大的远古龙签订了契约，从此开启了一段波澜壮阔的冒险之旅。',
    rating: 9.4,
    views: 1050000,
    chapters: 195,
    status: '连载中',
    tags: ['学院', '龙', '冒险'],
    updatedAt: '2026-08-04',
    chapters_list: [
      { num: 195, title: '龙神的试炼', date: '2026-08-04' },
      { num: 194, title: '终极对决', date: '2026-08-01' },
      { num: 193, title: '远古之龙', date: '2026-07-29' },
      { num: 192, title: '黑暗降临', date: '2026-07-26' },
      { num: 191, title: '龙骑士集结', date: '2026-07-23' },
    ],
  },
];

export const heroSlides = [
  {
    id: 1,
    comicSlug: 'the-legendary-return',
    title: '传奇归来',
    subtitle: '最强战士的异世界重生之旅',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20banner%20art%2C%20powerful%20warrior%20silhouette%20against%20golden%20sunset%2C%20magical%20energy%20particles%2C%20dramatic%20landscape%20with%20mountains%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20wide%20composition%2C%20epic%20fantasy%20atmosphere%2C%20professional%20illustration%20style&width=1400&height=600&seq=hero-slide-01&orientation=landscape',
    badge: '热门推荐',
  },
  {
    id: 2,
    comicSlug: 'the-last-witch',
    title: '最后的魔女',
    subtitle: '魔法世界的终极命运',
    image: 'https://readdy.ai/api/search-image?query=Mystical%20fantasy%20Korean%20manhwa%20banner%20art%2C%20elegant%20witch%20surrounded%20by%20floating%20magical%20runes%2C%20purple%20and%20silver%20ethereal%20light%2C%20starry%20night%20sky%2C%20magical%20forest%20setting%2C%20cinematic%20wide%20composition%2C%20enchanting%20and%20mysterious%20atmosphere&width=1400&height=600&seq=hero-slide-02&orientation=landscape',
    badge: '新作上线',
  },
  {
    id: 3,
    comicSlug: 'dragon-academy',
    title: '龙之学院',
    subtitle: '平凡少年的龙骑士之路',
    image: 'https://readdy.ai/api/search-image?query=Epic%20dragon%20academy%20Korean%20manhwa%20banner%20art%2C%20majestic%20dragons%20flying%20over%20ancient%20castle%2C%20students%20in%20robes%2C%20golden%20sunrise%20lighting%2C%20grand%20fantasy%20atmosphere%2C%20warm%20orange%20and%20gold%20tones%2C%20cinematic%20wide%20composition%2C%20epic%20scale&width=1400&height=600&seq=hero-slide-03&orientation=landscape',
    badge: '人气爆款',
  },
];

export const rankings = [
  { rank: 1, comicSlug: 'the-legendary-return', title: '传奇归来', views: 1280000, trend: 'up' },
  { rank: 2, comicSlug: 'the-last-witch', title: '最后的魔女', views: 1100000, trend: 'up' },
  { rank: 3, comicSlug: 'dragon-academy', title: '龙之学院', views: 1050000, trend: 'up' },
  { rank: 4, comicSlug: 'sweet-office-romance', title: '甜蜜办公室', views: 960000, trend: 'down' },
  { rank: 5, comicSlug: 'joseon-doctor', title: '朝鲜神医', views: 910000, trend: 'up' },
  { rank: 6, comicSlug: 'shadow-hunter', title: '暗影猎手', views: 850000, trend: 'down' },
  { rank: 7, comicSlug: 'midnight-detective', title: '午夜侦探社', views: 780000, trend: 'up' },
  { rank: 8, comicSlug: 'city-of-stars', title: '星之城', views: 720000, trend: 'up' },
  { rank: 9, comicSlug: 'love-in-seoul', title: '首尔恋爱物语', views: 680000, trend: 'down' },
  { rank: 10, comicSlug: 'demon-slayer-kim', title: '鬼神猎人金氏', views: 590000, trend: 'new' },
];

export const faqs = [
  {
    question: '妖精漫画上的韩国漫画是免费的吗？',
    answer: '是的！妖精漫画作为免费阅读韩漫官网，所有韩国漫画作品均提供免费在线阅读服务。我们致力于为广大漫画爱好者打造海量韩国漫画作品任你选的阅读入口，无需付费即可畅享高品质韩漫内容。',
  },
  {
    question: '网站上的韩漫多久更新一次？',
    answer: '我们紧跟韩国漫画的官方更新节奏，热门作品通常每周更新2-3话。你可以在"最新更新"板块实时查看各作品的更新状态，确保不错过任何精彩剧情。',
  },
  {
    question: '如何找到自己喜欢的韩漫类型？',
    answer: '妖精漫画提供清晰的分类导航系统，涵盖恋爱甜宠、奇幻冒险、热血动作、都市剧情、悬疑惊悚、搞笑日常、古风穿越等多种类型。你可以在首页分类导航区域或顶部导航栏快速筛选感兴趣的漫画类型。',
  },
  {
    question: '支持手机阅读吗？',
    answer: '当然支持！妖精漫画官网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论在通勤路上还是在家休息，你都能随时随地享受流畅的韩漫阅读体验。',
  },
  {
    question: '如何反馈问题或提出建议？',
    answer: '你可以通过"关于我们"页面的联系方式与我们取得联系。我们非常重视每一位读者的反馈，会认真对待每一条建议，持续优化和完善妖精漫画的阅读体验。',
  },
];